import React, { useEffect, useState, createContext } from "react";
import Header from "../../components/headerAdmin/Header";
import "./pendingResumeValidationsPage.css";
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PendingResumeValidationsForm from "../../components/pendingResumeValidationsForm/pendingResumeValidationsForm";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import getAllPendingResumes from "../../apis/pendingResumeById/pendingResumeById";
import debounce from 'lodash/debounce';
import DataTable from "../../components/DataTable/DataTable";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
import AutoComplete from "../../components/AutoComplete/AutoComplete";
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import countNoOfFilesParsed from "../../apis/parsing/countNoOfFilesParsed";
import { useSearchParams } from 'react-router-dom';

const PendingResumeValidationsContext = createContext();
export { PendingResumeValidationsContext };

const styleSx = {
    odd: {
        background: '#F6F6F6 !important'
    },
    even: {
        background: '#fffff !important'
    },
    notCompleteCell: {
        backgroundColor: " rgba(255, 65, 65, 0.27)",
        border: "none",
        cursor: "pointer"
    },
    completeCell: {
        border: "none",
    }
}

const PendingResumeValidationsPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    let active
    const [params] = useSearchParams();
    active = params.get("active") === "true";

    const id = location?.state?.id ? location?.state?.id : props?.id;
    const userRecruitmentpartnerId = location?.state?.recruitmentPartnerId ? location?.state?.recruitmentPartnerId : props?.userRecruitmentpartnerId;
    const userType = location?.state?.userType ? location?.state?.userType : props?.userType;
    const userRole = location?.state?.userRole ? location?.state?.userRole : props?.userType;
    const userRecords = location?.state?.userRecords ? location?.state?.userRecords : props?.userRecords;

    const idContextTest = id

    const [showPendingResumeForm, setShowPendingResumeForm] = useState(false);
    const [clickedRowItem, setClickedRowItem] = useState({});
    const [candidateResume, setCandidateResume] = useState({});
    const [candidateResumeId, setCandidateResumeId] = useState("");
    const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalResult, setTotalResult] = useState(0);
    const [searchTerms, setSearchTerms] = useState([]);
    const [isSearching, setIsSearching] = useState(true)
    const [dataResult, setDataResult] = useState([]);
    const [showParsingOverlay, setShowParsingOverlay] = useState(false);
    const [parsedCount, setParsedCount] = useState(0);
    const [totalFilesCount, setTotalFilesCount] = useState(0);
    const [pollingActive, setPollingActive] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState(null);
    useEffect(() => {

        if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
            navigate(location.pathname, { replace: true });
            active = false;
            sessionStorage.removeItem('uploadedResumeData');
        }
    }, []);

    useEffect(() => {
        const uploadedData = sessionStorage.getItem('uploadedResumeData');
        if (uploadedData) {
            try {
                const decodedData = JSON.parse(atob(uploadedData));
                const { uploadedFiles: files, timestamp } = decodedData;
                if (files && files.length > 0 && active) {
                    setShowParsingOverlay(true);
                    setTotalFilesCount(files.length);
                    setParsedCount(0);
                    setUploadedFiles(files);
                    setPollingActive(true);
                }
            } catch (error) {
                console.error('Error parsing uploaded resume data:', error);
                sessionStorage.removeItem('uploadedResumeData');
            }
        }
    }, []);

    useEffect(() => {
        if (!pollingActive || !uploadedFiles) return;

        const pollParsingStatus = async () => {
            try {
                const response = await countNoOfFilesParsed(uploadedFiles);
                if (response.status === 200) {
                    const count = response.data.count;
                    setParsedCount(count);

                    if (count >= uploadedFiles.length) {
                        setPollingActive(false);
                        setTimeout(() => {
                            setShowParsingOverlay(false);
                            sessionStorage.removeItem('uploadedResumeData');
                            window.location.reload();
                        }, 1500);
                    }
                }
            } catch (error) {
                console.error('Error polling parsing status:', error);
            }
        };

        pollParsingStatus();

        const intervalId = setInterval(pollParsingStatus, 5000);

        return () => {
            clearInterval(intervalId);
        };
    }, [pollingActive, uploadedFiles]);


    useEffect(() => {
        if (active) {
            return;
        }

        const debouncedSearch = debounce(async () => {
            try {
                setIsSearching(true);
                const search = await getAllPendingResumes(
                    userRecruitmentpartnerId,
                    searchTerms,
                    pageNumber,
                    takeNumberOfResult,
                    userType
                );
                setDataResult(search.data);
                setTotalResult(search.count);
            } catch (error) {
                console.error("Error fetching resumes:", error);
            } finally {
                setIsSearching(false);
            }
        }, 1000);

        debouncedSearch();

        return () => {
            debouncedSearch.cancel();
        };
    }, [searchTerms, pageNumber, takeNumberOfResult, userRecruitmentpartnerId, userType]);

    const goToMyTalent = (e) => {
        if (!showPendingResumeForm) {
            navigate("/dashboard",
                {
                    state: {
                        userType: userType,
                        recruitmentPartnerId: userRecruitmentpartnerId,
                        id: idContextTest,
                        userRecords: userRecords,
                        roleName: userRole
                    }
                });
        } else {
            setShowPendingResumeForm(false);
        }
    };

    const rowClickHandler = (item) => {
        setCandidateResume(item);
        setShowPendingResumeForm(true);
        setClickedRowItem(item);
        setCandidateResumeId(item?.candidateResumeId);
    };

    const handlePageChange = (newPage, newPageSize) => {
        setPageNumber(newPage);
        if (newPageSize && newPageSize !== takeNumberOfResult) {
            setTakeNumberOfResult(newPageSize);
        }
    }

    const handlePageSizeChange = (newPageSize) => {
        setTakeNumberOfResult(newPageSize);
        setPageNumber(1);
    };

    const handleFilterChange = (filters) => {
        let updatedFilters = []
        filters.forEach((filter) => {
            let filterObj = {
                field: filter.id,
                operator: "contains",
                value: filter.value
            };
            updatedFilters.push(filterObj);
        })
        setPageNumber(1);
        setSearchTerms(updatedFilters);
    }

    const statusOptions = [
        { label: 'All', value: '' },
        { label: 'True', value: 'true' },
        { label: 'False', value: 'false' }
    ];

    function isProfileCompleteFilterFn(row, columnId, filterValue) {
        if (!filterValue) return true;
        const rowValue = row.getValue(columnId);
        const filterValLower = filterValue.toLowerCase();
        if (filterValLower === 'true') return rowValue === true;
        if (filterValLower === 'false') return rowValue === false;
        return true;
    }

    const getIsProfileCompleteFilterValue = (column) => {
        const filterValue = column.getFilterValue();
        let value = statusOptions.find(opt => opt.value === filterValue);
        if (!value) {
            value = { label: 'All', value: '' };
        }
        return value;
    }

    const columns = [
        {
            accessorKey: "name", header: "Name", size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };

                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;

                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            }
        },
        {
            accessorKey: "emailID", header: "Email", size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };

                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;

                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            }
        },
        {
            accessorKey: "phoneNumber", header: "Phone", size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };

                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;

                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            }
        },
        {
            accessorKey: "recruiterName",
            header: "Uploaded by", size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };

                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;

                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            },
            cell: (info) => {
                const val = info.getValue();
                if (!val || val === "Unknown") {
                    return null;
                }
                return val;
            },
        },
        {
            accessorKey: "updatedAt",
            header: "Uploaded Date",
            size: 150,
            enableSorting: true,
            enableColumnFilter: false,
            cell: ({ getValue }) => {
                const date = getValue();
                if (!date) return '';
                return new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                });
            },
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };

                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;

                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            }
        },
        {
            id: "Status",
            accessorKey: "isProfileComplete",
            header: "Status",
            cell: ({ row }) => <td className="status_icons">
                <span className={`icon ${row.original.isProfileComplete ? 'success' : 'error'}`}>
                    {row.original.isProfileComplete ? (
                        <Tooltip title="Profile Completed" placement="top"><CheckCircleIcon /></Tooltip>
                    ) : (
                        <Tooltip title="Profile Not Completed" placement="top"><ErrorIcon /></Tooltip>
                    )}
                </span>
            </td>,
            size: 100,
            enableSorting: false,
            enableColumnFilter: true,
            filterFn: isProfileCompleteFilterFn,
            Filter: ({ column }) => (
                <AutoComplete
                    disableClearable
                    className='isProfileCompleteFilter-autocomplete'
                    options={statusOptions}
                    value={getIsProfileCompleteFilterValue(column)}
                    onChange={(event, newValue) => {
                        column.setFilterValue(newValue ? newValue.value : '');
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                        />
                    )}
                    sx={{ width: '100%' }}
                />
            ),
            meta: ({ row }) => {
                const shouldHighlight = !row.original.isProfileComplete;

                const handleNameClick = () => {
                    rowClickHandler(row.original);
                };
                const highlightStyle = shouldHighlight ? styleSx.notCompleteCell : styleSx.completeCell;
                return {
                    style: { ...highlightStyle },
                    onClick: handleNameClick
                };
            }
        },
    ]

    return (
        <>
            <div className="talentCommunityMainContainer">
                <div>
                    <Header />
                    {(userType === "Candidate") ? (
                        <UnauthorizedAccess />
                    ) : <>

                        <div className="pending_resume_container">
                            <div className="communityHeader_Resvalidation">
                                <div className="goBackButton" onClick={(e) => goToMyTalent(e)}>
                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                    </Tooltip>
                                </div>
                                <div className="communityTitle">Pending Resume Validations</div>
                            </div>
                            {!showPendingResumeForm && dataResult.length >= 0 ? (
                                <DataTable
                                    columns={columns}
                                    data={dataResult}
                                    isLoading={isSearching}
                                    totalRecords={totalResult}
                                    currentPage={pageNumber}
                                    pageSize={takeNumberOfResult}
                                    onPageChange={handlePageChange}
                                    onPageSizeChange={handlePageSizeChange}
                                    onFilterChange={handleFilterChange}
                                    enablePagination={true}
                                    className='searchCandidateTable_pendingResume'
                                    enableSorting={false}
                                    pageSizeOptions={[10, 20, 50, 100]}
                                    isServerSide={true}
                                    noDataText="No results found !"
                                />

                            ) : (
                                <PendingResumeValidationsForm
                                    idContextTest={idContextTest}
                                    clickedRowItem={clickedRowItem}
                                    candidateResume={candidateResume}
                                    setShowPendingResumeForm={setShowPendingResumeForm}
                                    showPendingResumeForm={showPendingResumeForm}
                                    userType={userType}
                                    dataResult={dataResult}
                                    setDataResult={setDataResult}
                                    userRecruitmentpartnerId={userRecruitmentpartnerId}
                                    candidateResumeId={candidateResumeId}
                                />
                            )}

                        </div>
                    </>
                    }
                </div>
            </div>

            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: 9999,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                }}
                open={showParsingOverlay}
            >
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress
                        size={60}
                        thickness={4}
                        sx={{ color: '#31B3F8' }}
                    />
                    <Typography
                        variant="h5"
                        sx={{
                            mt: 3,
                            fontFamily: '"Segoe UI Semibold", sans-serif',
                            fontWeight: 600,
                            color: '#ffffff'
                        }}
                    >
                        Processing Resumes...
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            mt: 2,
                            fontFamily: '"Segoe UI", sans-serif',
                            color: '#e0e0e0'
                        }}
                    >
                        {parsedCount} of {totalFilesCount} files parsed
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            mt: 1,
                            fontFamily: '"Segoe UI", sans-serif',
                            color: '#bdbdbd',
                            fontSize: '14px'
                        }}
                    >
                        Please wait while we process your uploaded resumes
                    </Typography>
                </div>
            </Backdrop>
        </>
    );
};

export default PendingResumeValidationsPage;